import { BYTES_PER_KB, FILE_SIZE_UNITS } from './constants';

export const formatFileSize = (bytes: number | undefined): string => {
  if (!bytes) return '0 B';
  const i = Math.floor(Math.log(bytes) / Math.log(BYTES_PER_KB));
  return `${parseFloat((bytes / BYTES_PER_KB ** i).toFixed(2))} ${FILE_SIZE_UNITS[i]}`;
};
